/** Grenzen für ISO-Datumsfelder (Jahr maximal 4 Ziffern). */
export const BOOKING_DATE_MAX = "9999-12-31";
export const BOOKING_BIRTH_DATE_MIN = "1900-01-01";

export function hasValidFourDigitYear(iso: string): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return false;
  const year = Number(iso.slice(0, 4));
  return Number.isFinite(year) && year >= 1000 && year <= 9999;
}

/** Normalisiert Eingaben von type="date" – Jahr auf 4 Ziffern begrenzen. */
export function normalizeDateInputValue(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return "";

  const parts = trimmed.split("-");
  if (parts.length !== 3) return trimmed;

  const [yearStr, month, day] = parts;
  if (!/^\d+$/.test(yearStr)) return "";

  const normalizedYear = yearStr.slice(0, 4);
  return `${normalizedYear}-${month}-${day}`;
}
